<template>
  <div v-if="isNoValidation || !props.product.not_display_product_list" :class="$style.product_list_item">
    <div :class="[$style.thumb, { [$style.out_of_stock]: !product.search_product.is_in_stock }]">
      <AtomsConsumerLink
        :url="product.search_product.product_page_url"
        :disabled="!product.search_product.product_page_url || isDisableLink"
      >
        <AtomsConsumerImage
          :src="`${product.search_product.lowest_price_sku.main_image}`"
          :alt="
            product.top_image_alt
              ? product.top_image_alt
              : `${product.name}${product.material ? ' / ' + product.material : ''}`
          "
          :width="184 * 2"
          :height="245 * 2"
          :class="$style.img"
        />
        <ProductLabelBasic
          :is-out-of-stock="!product.search_product.is_in_stock"
          :is-general-medical-device="!!product.is_general_medical_device"
          :is-quasi-drug="!!product.is_quasi_drug"
          :is-duvet-collection="!!product.is_duvet_collection"
          :promotion-labels="product.search_product.promotion_labels"
          :class="$style.promotion_labels"
        />
      </AtomsConsumerLink>
    </div>
    <AtomsConsumerLink
      :url="product.search_product.product_page_url"
      :disabled="!product.search_product.product_page_url || isDisableLink"
      :class="$style.product_detail"
    >
      <div :class="$style.description_box">
        <p :class="[$style.name, $style.second_dotted_line]">{{ product.name }}</p>
        <p :class="[$style.description_text, $style.second_dotted_line]">{{ product.material }}</p>
        <div :class="$style.description_text">
          <span v-if="product.sex">{{ getSexLabel(product.sex) }}</span>
          <span v-if="product.sex && product.size_range">/</span>
          <span v-if="product.size_range">{{ product.size_range }}</span>
        </div>
        <p v-if="product.search_product.sku_colors > 0" :class="$style.description_text">
          {{ product.search_product.sku_colors }}カラー
        </p>
        <div :class="$style.price">
          <div
            :class="{
              [$style.discount]: product.search_product.lowest_price_sku.discounted_price,
            }"
          >
            <span :class="$style.yen">&yen; </span>
            <span>
              {{ product.search_product.lowest_price_sku.calc_price_result.effective_reference_price_comma }}
            </span>
            <span :class="$style.tax">(参考税込)</span>
          </div>
          <AtomsConsumerButton :class="$style.bookmark" @click="$emit('openFavModal', $event)">
            <AtomsConsumerImage src="/images/icon/fav.svg" alt="お気に入り" :width="20" :height="20" />
          </AtomsConsumerButton>
        </div>
      </div>
      <AtomsConsumerButton variant="secondary" rounded block @click="openAddCartModal($event, product.document_id)">
        カートに追加
      </AtomsConsumerButton>
    </AtomsConsumerLink>
  </div>
</template>

<script setup lang="ts">
import { SEX_ITEMS } from "~/const/product"
import { PagePartsProductType } from "~/types/product"
import type { ApiProductSearchResponse_Product } from "~/types/server/api/product"
import { useCart } from "~/composables/useCart"

const { cartState } = useCart()

type Props = {
  product: ApiProductSearchResponse_Product
  /** リンク化しない（親コンポーネントでモーダルを出すなどの場合）(default: false) */
  isDisableLink?: boolean
  /** 商品一覧に表示しない商品も表示する(default: false) */
  isNoValidation?: boolean
  /** 横長タイプ */
  isHorizontal?: boolean
  /** 縦長タイプ */
  isVertical?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  isDisableLink: false,
  isNoValidation: false,
  isHorizontal: false,
  isVertical: false,
})

const getSexLabel = (sexValue: string): string => {
  for (const item of SEX_ITEMS) {
    if (item.value === sexValue) return item.key
  }
  return ""
}

const openAddCartModal = (e: Event, productId: string) => {
  e.preventDefault()
  cartState.quickViewProductId = productId
}

defineEmits<{
  (e: "openQuickView", $event: Event, product: PagePartsProductType): void
  (e: "openFavModal", $event: Event): void
}>()
</script>

<style scoped module lang="scss">
@import "assets/scss/components/ProductListItemStyle.scss";
</style>
